import { NavLink } from 'react-router-dom';

const items = [
  { to: '/dashboard', label: 'Дашборд' },
  { to: '/offers', label: 'Офферы' },
  { to: '/customers', label: 'Пользователи' },
  { to: '/payouts', label: 'Выплаты' },
  { to: '/settings', label: 'Настройки' }
];

function Sidebar() {
  return (
    <aside className="sidebar">
      <div className="brand-block">
        <span className="brand-kicker">toptopaff.com</span>
        <h1>Админ-панель</h1>
      </div>

      <nav className="nav-list" aria-label="Основная навигация">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `nav-link${isActive ? ' nav-link-active' : ''}`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;